import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import { Input } from "@/components/ui/input";
import { Contact, Search } from "lucide-react";

export default function AccountingClients() {
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/accounting/clients").then((r) => setList(r.data.clients)).catch(() => {}); }, []);
  const shown = list.filter((c) => `${c.company_name} ${c.nip || ""} ${c.country || ""}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <div className="min-h-screen bg-[#FAFAF8]">
      <Navbar />
      <main className="max-w-5xl mx-auto px-6 py-8" data-testid="accounting-clients-page">
        <div className="flex items-center gap-2.5 mb-5">
          <Contact className="h-5 w-5 text-[#193962]" />
          <h1 className="font-[Outfit] text-2xl font-semibold tracking-tight">Kontrahenci</h1>
          <span className="text-xs text-muted-foreground">tylko do odczytu · {list.length}</span>
        </div>
        <div className="relative mb-4">
          <Search className="h-4 w-4 absolute left-3 top-3 text-muted-foreground" />
          <Input className="pl-9 bg-white" placeholder="Szukaj po nazwie, NIP, kraju" value={q} onChange={(e) => setQ(e.target.value)} data-testid="accounting-clients-search" />
        </div>
        <div className="border border-border bg-white rounded-md divide-y divide-border" data-testid="accounting-clients-list">
          {shown.length === 0 && <p className="p-5 text-sm text-muted-foreground">Brak kontrahentów.</p>}
          {shown.map((c) => (
            <div key={c.client_id} className="px-4 py-3 text-sm flex flex-wrap gap-x-4 gap-y-1" data-testid={`accounting-client-${c.client_id}`}>
              <span className="font-medium flex-1 min-w-[200px]">{c.company_name}</span>
              <span className="text-zinc-600 tabular-nums">{c.nip ? `NIP ${c.nip}` : "—"}</span>
              <span className="text-zinc-500 basis-full sm:basis-auto">{[c.address, c.country].filter(Boolean).join(" · ")}</span>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
